import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Row, Col } from "reactstrap";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { toast } from "../../../../core/helpers/message-helper";
import { selectGrupos } from '../../services/permisos-grupos-service';
import { crearOEditarPermiso } from '../../services/permisos-service';

const FormPermisos = ({ modalState, onSave }) => {
    const { permiso } = modalState.data;
    const [grupos, setGrupos] = useState([]);

    const defaultValues = {
        id: permiso.id || "",
        permission_name: permiso.permission_name || "",
        name: permiso.name || "",
        description: permiso.description || "",
        permission_group_id: permiso.permission_group_id
            ? {
                  label: permiso.grupo,
                  value: permiso.permission_group_id,
              }
            : "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [permiso]);

    const onCreatePermiso = async (permiso) => {
        permiso.permission_group_id = permiso.permission_group_id.value;
        const resp = await crearOEditarPermiso(permiso);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    useEffect(async () => {
        const resp = await selectGrupos();
        if (!resp.status) return toast.error(resp.message);

        const grupos = resp.data.map((grupo) => {
            return {
                value: grupo.id,
                label: grupo.nombre,
            };
        });

        setGrupos(grupos);
    }, []);

    return (
        <FormModal
            size="lg"
            form={form}
            id="formPermiso"
            onSubmit={onCreatePermiso}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={4}>
                    <InputController
                        name="permission_name"
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Nombre"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={4}>
                    <InputController
                        name="name"
                        label="Codigo"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Nombre"
                        readOnly={permiso.id != null}
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={4}>
                    <SelectController
                        options={grupos}
                        label="Grupo"
                        errors={form.formState.errors}
                        control={form.control}
                        name="permission_group_id"
                        rules={{ required: "Este campo es requerido" }}
                        placeholder="Grupo"
                    />
                </Col>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        label="Descripción"
                        errors={form.formState.errors}
                        control={form.control}
                        name="description"
                        rules={{ required: "Este campo es requerido" }}
                        placeholder="Descripción"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormPermisos.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormPermisos;
